import * as React from 'react';

import classnames from 'classnames';

import {Illustration} from 'shells/illustrations/illustration';
import {MarketingBody} from 'shells/typography/marketing-body';
import {MarketingHeader} from 'shells/typography/marketing-header';

import styles from './pause-page.module.css';

export function RestoreRequestedPage() {
    return (
        <div className={classnames('pad-16', styles['pause-page'])}>
            <MarketingHeader>We’re getting your account reactivated</MarketingHeader>
            <div className={classnames('flex', styles.body)}>
                <div className={styles.copy}>
                    <MarketingBody>
                        Our support team is re-opening your account using your existing Nutshell
                        Starter plan and rate.
                    </MarketingBody>
                    <MarketingBody>
                        Keep an eye out for an email within the next business day. We’ll let you
                        know as soon as things are up and running.
                    </MarketingBody>
                    <MarketingBody>We’re glad to have you back!</MarketingBody>
                </div>
                <Illustration src='timer' />
            </div>
        </div>
    );
}
